export const parseIfNecessary = (val: unknown) => {
  try {
    return JSON.parse(val as string);
  } catch (e) {
    return val;
  }
};
